import {
  Database,
  Cloud,
  Zap,
  Layers,
  FileCode,
  Code,
  Shield,
  Cog,
  Workflow,
  Settings,
  RefreshCw,
  Book,
  FileText,
} from "lucide-react";

export const modernizationTools = [
  {
    id: "scontrols-to-lwc",
    title: "Move S-Controls to LWC",
    description: "Convert legacy S-Controls to modern Lightning Web Components",
    icon: Code,
    category: "Component Migration",
    difficulty: "Advanced",
    estimatedTime: "2-4 hours",
    benefits: [
      "Better performance",
      "Modern UI",
      "Mobile responsive",
      "Secure",
    ],
    color: "from-blue-500 to-cyan-600",
  },
  {
    id: "vf-to-lwc",
    title: "VF Pages to LWC",
    description: "Migrate Visualforce pages to Lightning Web Components",
    icon: Zap,
    category: "Component Migration",
    difficulty: "Intermediate",
    estimatedTime: "1-3 hours",
    benefits: ["Faster loading", "Better UX", "Lightning Experience ready"],
    color: "from-purple-500 to-pink-600",
  },
  {
    id: "workflows-to-flow",
    title: "Workflows to Flow",
    description: "Convert legacy Workflow Rules to modern Flow Builder",
    icon: Workflow,
    category: "Process Automation",
    difficulty: "Beginner",
    estimatedTime: "30 min - 1 hour",
    benefits: ["Visual design", "More flexibility", "Better debugging"],
    color: "from-green-500 to-emerald-600",
  },
  {
    id: "process-builder-to-flow",
    title: "Process Builder to Flow",
    description: "Migrate Process Builder processes to Flow Builder",
    icon: Settings,
    category: "Process Automation",
    difficulty: "Beginner",
    estimatedTime: "30 min - 1 hour",
    benefits: ["Improved performance", "Better maintenance", "Future-proof"],
    color: "from-orange-500 to-red-600",
  },
  {
    id: "triggers-to-framework",
    title: "Triggers to Framework",
    description: "Refactor Apex triggers using best practice frameworks",
    icon: Database,
    category: "Code Quality",
    difficulty: "Advanced",
    estimatedTime: "2-6 hours",
    benefits: [
      "Better maintainability",
      "Reduced governor limits",
      "Testable code",
    ],
    color: "from-indigo-500 to-purple-600",
  },
  {
    id: "upgrade-security",
    title: "Upgrade Security",
    description: "Enhance security with latest Salesforce security features",
    icon: Shield,
    category: "Security",
    difficulty: "Intermediate",
    estimatedTime: "1-2 hours",
    benefits: ["Better data protection", "Compliance ready", "Risk reduction"],
    color: "from-red-500 to-pink-600",
  },
  {
    id: "api-versions",
    title: "Move API Versions",
    description: "Update components to use the latest Salesforce API versions",
    icon: RefreshCw,
    category: "Maintenance",
    difficulty: "Intermediate",
    estimatedTime: "1-2 hours",
    benefits: [
      "New features access",
      "Better performance",
      "Future compatibility",
    ],
    color: "from-teal-500 to-cyan-600",
  },
  {
    id: "know-formulas",
    title: "Know Your Formulas",
    description: "Analyze and optimize formula fields across your org",
    icon: Book,
    category: "Analytics",
    difficulty: "Beginner",
    estimatedTime: "30 min",
    benefits: [
      "Performance insights",
      "Formula optimization",
      "Best practices",
    ],
    color: "from-yellow-500 to-orange-600",
  },
  {
    id: "create-documentation",
    title: "Create Documentation",
    description: "Generate comprehensive documentation for your Salesforce org",
    icon: FileText,
    category: "Documentation",
    difficulty: "Beginner",
    estimatedTime: "15-30 min",
    benefits: [
      "Better maintainability",
      "Team collaboration",
      "Knowledge sharing",
    ],
    color: "from-gray-500 to-slate-600",
  },
];

export const modernizationCategories = [
  "All",
  "Apex",
  "UI/UX",
  "Database",
  "Integration",
  "Security",
  "Automation",
  "Architecture",
];

export const sampleModernizationResults = {
  totalProcessed: 132,
  successful: 124,
  failed: 8,
  performanceGain: 37,
  codeReduction: 22,
};

export const categories = [
  "All",
  "Component Migration",
  "Process Automation",
  "Code Quality",
  "Security",
  "Maintenance",
  "Analytics",
  "Documentation",
];
